import React, { useState } from 'react';
import { cn } from '@/lib/utils';
import {
  MindfullMark,
  MINDFULL_MARK,
  type MindfullMarkMotion,
  type MindfullMarkVariant,
} from '@/components/brand/MindfullMark';

interface MindfullLogoProps {
  size?: 'sm' | 'md' | 'lg' | 'xl';
  showText?: boolean;
  className?: string;
  /** Mark direction; defaults to the shipped one. */
  variant?: MindfullMarkVariant;
  /** Play the mark's intro on mount and fan it open on hover. */
  animated?: boolean;
}

const markSize = { sm: 22, md: 26, lg: 32, xl: 44 } as const;

const textSizeClasses = {
  sm: 'text-[17px]',
  md: 'text-xl',
  lg: 'text-2xl',
  xl: 'text-3xl',
};

/** Mark plus "Mindfull" wordmark in the display face. */
export const MindfullLogo: React.FC<MindfullLogoProps> = ({
  size = 'md',
  showText = true,
  className,
  variant = MINDFULL_MARK,
  animated = false,
}) => {
  const [state, setState] = useState<MindfullMarkMotion>(animated ? 'intro' : 'still');

  return (
    <div
      className={cn('flex items-center gap-2 text-ink', className)}
      onMouseEnter={animated ? () => setState('open') : undefined}
      onMouseLeave={animated ? () => setState('rest') : undefined}
    >
      <MindfullMark
        variant={variant}
        size={markSize[size]}
        motion={state}
        title={showText ? undefined : 'Mindfull'}
      />
      {showText && (
        <span className={cn(textSizeClasses[size], 'font-display font-semibold tracking-[-0.02em] leading-none')}>
          Mindfull
        </span>
      )}
    </div>
  );
};

export default MindfullLogo;
